import {
  Box, BoxProps, Typography
} from '@mui/material'
import React, { PropsWithChildren } from 'react'

interface Props extends Pick<BoxProps, 'sx'> {
  title: string
}

const CardOptionsContainer: ReactFC<PropsWithChildren<Props>> = ({ children, title, sx }) => {
  if (React.Children.toArray(children).length > 3) {
    throw new Error(
      'CardOptionDisplayer can only receive a maximum of 3 options, provide other design to accept more'
    )
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.paper',
        borderRadius: 2,
        boxShadow: 1,
        minHeight: '65vh',
        ...sx
      }}
    >
      <Box
        sx={{
          width: '100%',
          height: '100%',
          display: 'grid',
          placeItems: 'center',
          padding: '5rem'
        }}
      >
        <Box>
          <Typography
            sx={{
              fontWeight: '700', fontSize: '1.4rem'
            }}
          >
            {title}
          </Typography>
        </Box>
        <Box
          sx={{
            height: 'calc(100% - 41px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-evenly',
            marginTop: '4rem',
            '& > *:not(:first-of-type)': {
              marginLeft: '3rem'
            }
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  )
}
export default CardOptionsContainer
